module.exports = __webpack_public_path__ + "img/sign-26.83c73dce.jpg";